import { useEffect, useMemo, useState } from "react"
import * as PropTypes from "prop-types"
import { useLocale } from "react-polyglot-hooks"
import Articles from "components/landing/Articles"
import { getBlogPosts } from "services/blogService"

function getWordpressTag(section) {
  return section?.wordpress_tag || section?.wordpressTag || ""
}

export default function WordpressArticles({ section, page }) {
  const locale = useLocale()
  const tag = getWordpressTag(section)
  const initialPosts = useMemo(() => (Array.isArray(section?.posts) ? section.posts : []), [section])
  const [posts, setPosts] = useState(initialPosts)

  useEffect(() => {
    let mounted = true

    if (initialPosts.length > 0 || !tag) {
      setPosts(initialPosts)
      return () => {
        mounted = false
      }
    }

    setPosts([])

    getBlogPosts(locale, tag).then(nextPosts => {
      if (mounted) setPosts(nextPosts)
    })

    return () => {
      mounted = false
    }
  }, [initialPosts, locale, tag])

  if (!tag || posts.length === 0) return null

  return (
    <Articles
      posts={posts}
      page={page}
      title={section.title || ""}
      translateTitle={false}
      minPosts={1}
    />
  )
}

WordpressArticles.defaultProps = {
  page: "seo"
}

WordpressArticles.propTypes = {
  section: PropTypes.object.isRequired,
  page: PropTypes.string
}
